import { OPEN_MODAL } from '../actionTypes';
import { addPanelsModalActions } from '../reducer';

export default (value) => addPanelsModalActions[OPEN_MODAL](value);
